import getFocusTrapEventHandler from './focus_trap'
import { preventOverflow } from './dropdown_menu_prevent_overflow'

const dropdownSelector = '.js-dropdown_redesign'
const dropdownToggleSelector = '.js-dropdown_toggle_redesign'
const dropdownMenuSelector = '.js-dropdown_menu_redesign'

const toggle = toggleButton => {
  const dropdown = toggleButton.closest(dropdownSelector)

  if (toggleButton.getAttribute('aria-expanded') !== 'true') {
    open(dropdown)
  } else {
    close(dropdown)
  }
}

up.compiler(dropdownToggleSelector, function (element) {
  element.addEventListener('click', function (event) {
    event.preventDefault()
    toggle(element)
  })
})

up.on('click', '.js-close_dropdown_redesign', (event, element) => {
  close(element.closest(dropdownSelector))
})

// close nav after clicking a link to make the website feel faster
up.on('click', '.js-dropdown_redesign a', (event, element) => {
  close(element.closest(dropdownSelector))
})

up.on('click', '.js-dropdown_redesign .js-dropdown_menu_item_redesign', (event, element) => {
  close(element.closest(dropdownSelector))
})

up.on('up:link:follow', '.js-dropdown_redesign a', (event, element) => {
  close(element.closest(dropdownSelector))
})

function onMenuElementKeyDown(e) {
  const dropdownElement = e.currentTarget
  const { onFocus } = getFocusTrapEventHandler(dropdownElement)
  onFocus(e)
}

function doPreventOverflow(eventOrElement) {
  const element = eventOrElement.target || eventOrElement
  const toggleButton = element.querySelector(dropdownToggleSelector)
  const menu = element.querySelector(dropdownMenuSelector)

  const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true'

  if (toggleButton && menu) {
    preventOverflow(false, isExpanded, toggleButton, menu)
  }
}

export const open = function (element) {
  const menu = element.querySelector(dropdownMenuSelector)
  const { focusFirst } = getFocusTrapEventHandler(menu)

  menu.removeAttribute('hidden')
  element.querySelector(dropdownToggleSelector).setAttribute('aria-expanded', 'true')
  element.addEventListener('keydown', onMenuElementKeyDown)
  focusFirst()

  doPreventOverflow(element)
}

export const close = element => {
  element.querySelector(dropdownMenuSelector).setAttribute('hidden', 'true')
  element.querySelector(dropdownToggleSelector).setAttribute('aria-expanded', 'false')
  element.removeEventListener('keydown', onMenuElementKeyDown)
}

up.compiler(dropdownSelector, function (element) {
  const closeIfClickOutside = function (event) {
    if (!element.contains(event.target)) {
      close(element)
    }
  }

  const onResize = () => doPreventOverflow(element)
  window.addEventListener('click', closeIfClickOutside)
  window.addEventListener('resize', onResize)

  return () => {
    window.removeEventListener('click', closeIfClickOutside)
    window.removeEventListener('resize', onResize)
  }
})
